export default __webpack_public_path__ + "static/media/Scarecrow.50042200.png";